module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fenceVoltage":"Fence voltage","impulses":"Impulses"},"de":{"fenceVoltage":"Spannung Weidezaun","impulses":"Impulse"},"fr":{"fenceVoltage":"Tension de la clôture","impulses":"Impulsions"},"it":{"fenceVoltage":"Voltaggio Recinzione","impulses":"Impulsi"}}')
  delete Component.options._Ctor
}
